import {assert} from 'Asserts';
import {DataFrameSpec} from 'data-frames/DataFrameTypes';
import {makeReactContext} from 'lib/makeReactContext';

export const StepConfigEditorContext = makeReactContext<{
  // We don't always have access to a persisted data frame, which is why this is optional. Is needed for any
  // editor components that require using the values of the data frame.
  dataFrameId?: string;
  dataFrameSpec: DataFrameSpec;
  // Usually the pipelineId, but for the TransformPopover in the flowchart its the step id because it is hard
  // to get the pipelineId, and the stepId works because you can't have the popover open while changing the
  // stepId.
  clientStateId: string;
}>(() => {
  assert(false, 'StepConfigEditorContext not initialized');
}, 'StepConfigEditorContext');

export function useStepConfigEditorContext(): {
  dataFrameId?: string;
  dataFrameSpec: DataFrameSpec;
  clientStateId: string;
} {
  return StepConfigEditorContext.useContext();
}
